import {defineStore} from 'pinia';
import {checkDocument} from "@js/helpers.ts";

export const useJivoStore = defineStore('jivoStore', {
    state: () => ({
        hasUnreadMessages: false,
    }),
    actions: {
        openJivoChat() {
            this.hasUnreadMessages = false;
            if (checkDocument()) return

            if (window.jivo_api && typeof window.jivo_api.open === 'function') {
                // Открываем окно чата в режиме «chat»
                window.jivo_api.open({start: 'chat'});
            } else {
                console.warn('Jivo API не инициализирован');
            }
        },
        jivoOnMessageReceived() {
            this.hasUnreadMessages = true
            console.log(123,this.hasUnreadMessages)
        }
    }
});

